import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { WasteOrderType } from '../../interfaces/configuration/waste-order-type';

@Injectable()

export class WasteOrderTypeService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<WasteOrderType[] | boolean> {
    return new Observable<WasteOrderType[] | boolean>((o: Subscriber<WasteOrderType[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.waste-order.type.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<WasteOrderType[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<WasteOrderType | boolean> {
    return new Observable<WasteOrderType | boolean>((o: Subscriber<WasteOrderType | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.waste-order.type.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<WasteOrderType>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('configuration.waste-order.type.update', {':id': id}), formData);
  }

  copy(id: number): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('configuration.waste-order.type.copy', {':id': id}));
  }
}
